import { formatPrice } from '@nktkas/hyperliquid/utils';

/** Allows in-flight decimal input: digits and at most one dot. */
export const DECIMAL_DRAFT = /^\d*\.?\d*$/;

export const isPositivePrice = (price: number | null | undefined): price is number =>
  typeof price === 'number' && Number.isFinite(price) && price > 0;

/** Value of a positive decimal string, whether typed in a field or sent by the exchange. */
export const parsePositiveDecimal = (value: string) => {
  const parsed = Number(value);
  return DECIMAL_DRAFT.test(value) && isPositivePrice(parsed) ? parsed : undefined;
};

/**
 * A price at the market's tick precision with USD grouping, e.g. `$86,540` or `$0.012345`.
 * Keeps exactly the decimals `formatPrice` yields, so low-priced markets are not rounded to cents.
 */
export const formatUsdPrice = (price: string | number, szDecimals: number) => {
  const tick = formatPrice(price, szDecimals);
  const decimals = tick.split('.')[1]?.length ?? 0;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(Number(tick));
};
